// client/src/components/OrderTypeSelectionModal.js
import React from 'react';
import { Modal, Button, Row, Col, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function OrderTypeSelectionModal({ show, handleClose, onSelectOrderType }) {
  // Define the available order types as per your backend schema
  const orderTypes = ['New Cover', 'Reskin', 'Remod', 'Repair', 'Parts'];

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="w-100 text-center">Select Order Type</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <Row xs={1} md={2} lg={3} className="g-4 justify-content-center">
          {orderTypes.map((type) => (
            <Col key={type}>
              <Card
                className="h-100 text-center shadow-sm d-flex flex-column justify-content-between"
                style={{ cursor: 'pointer', transition: 'transform 0.2s ease-in-out' }}
                onClick={() => onSelectOrderType(type)} // Call the prop function on card click
              >
                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                  <Card.Title className="mb-0 fw-bold">{type}</Card.Title>
                </Card.Body>
                {/* Optional: Add a button inside the card for better clickability */}
                <Button variant="primary" className="w-100 rounded-0" onClick={() => onSelectOrderType(type)}>
                  Select
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default OrderTypeSelectionModal;
